import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex flex-col gap-6 md:gap-8',
    title: 'heading-2xl md:heading-3xl-desk container'
  }
});
